export default __webpack_public_path__ + "static/media/icon-expired-email-marketing.953b8b4b.svg";